import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface GradeCardProps {
  className?: string;
  grade: string;
}

function GradeCard({ className, grade }: GradeCardProps) {
  const { t } = useTranslation();

  const gradeComments: { [key: string]: string } = {
    S: t("foreign-employment-assessment-S"),
    A: t("foreign-employment-assessment-A"),
    B: t("foreign-employment-assessment-B"),
    C: t("foreign-employment-assessment-C"),
    D: t("foreign-employment-assessment-D"),
  };

  const comment = gradeComments[grade] || t("invalid-grade");

  return (
    <div
      className={twMerge(
        className,
        "flex gap-2 rounded-b-lg border-t-2 border-cyan-600 px-4 py-3 shadow",
      )}
    >
      <div className="flex flex-col items-center gap-2 min-w-[60px]">
        <div className="text-cyan-600">{t("grade")}</div>
        <div className="text-3xl font-bold text-cool-gray-900">{grade}</div>
      </div>
      <div className="text-sm text-cool-gray-600">{comment}</div>
    </div>
  );
}

export default GradeCard;
